<form [formGroup]="changePasswordForm" name="resetpasswordForm" class="mx-0 mt-4 mb-0" (ngSubmit)="OnSubmit()">
  <div class="fieldset" *ngIf="!this.code">
    <label for="oldPass" class="legend">Old Password</label>
    <div class="password-field">
      <input [type]="showOldPassword ? 'text' : 'password'" name="oldPass" id="oldPass" class="text-field" formControlName="oldpassword" autocomplete="current-password" required>
      <button type="button" class="password-toggle" (click)="showOldPassword = !showOldPassword"
              [attr.aria-label]="showOldPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showOldPassword">
        <i class="fa" [class.fa-eye]="!showOldPassword" [class.fa-eye-slash]="showOldPassword"></i>
      </button>
    </div>
    <div class="formError" *ngIf="changePasswordForm.get('oldpassword')?.invalid && changePasswordForm.get('oldpassword')?.touched">
      <span *ngIf="changePasswordForm.get('oldpassword')?.hasError('required')">Old password is required</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="Password" class="legend">New Password</label>
    <div class="password-field">
      <input [type]="showPassword ? 'text' : 'password'" name="Password" id="Password" class="text-field" formControlName="password" autocomplete="new-password" required>
      <button type="button" class="password-toggle" (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
        <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
      </button>
    </div>
    <app-password-strength *ngIf="changePasswordForm.get('password')?.touched" [password]="changePasswordForm.get('password')?.value"></app-password-strength>
    <div class="formError" *ngIf="changePasswordForm.get('password')?.invalid && changePasswordForm.get('password')?.touched">
      <span *ngIf="changePasswordForm.get('password')?.hasError('required')">Password is required</span>
      <span *ngIf="changePasswordForm.get('password')?.hasError('maxlength')">Password cannot exceed 64 characters</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="ConfirmPassword" class="legend">Confirm New Password</label>
    <div class="password-field">
      <input [type]="showCPassword ? 'text' : 'password'" name="ConfirmPassword" id="ConfirmPassword" class="text-field" formControlName="cpassword" autocomplete="new-password" required>
      <button type="button" class="password-toggle" (click)="showCPassword = !showCPassword"
              [attr.aria-label]="showCPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showCPassword">
        <i class="fa" [class.fa-eye]="!showCPassword" [class.fa-eye-slash]="showCPassword"></i>
      </button>
    </div>
    <div class="formError" *ngIf="changePasswordForm.get('cpassword')?.invalid && changePasswordForm.get('cpassword')?.touched">
      <span >Passwords do not match</span>
    </div>
  </div>
  <button *ngIf="!isLoading; else resettingPassword" type="submit" class="btn" [disabled]="changePasswordForm.invalid">Reset password</button>
  <ng-template #resettingPassword>
    <button class="btn btn--loading" type="button">Resetting your password...</button>
  </ng-template>
</form>
